import { render, staticRenderFns } from "./SpeakerPage.vue?vue&type=template&id=8b526984&"
import script from "./SpeakerPage.vue?vue&type=script&lang=js&"
export * from "./SpeakerPage.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VIcon,VSkeletonLoader})
